import React from 'react';
import { Dialog, DialogContent } from '@mui/material';

const VideoModal = ({ open, onClose, video }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogContent dividers>
      {video && (
        <video
          key={video.file}
          src={video.file}
          controls
          controlsList="nodownload"
          style={{ width: '100%', maxHeight: '70vh' }}
        >
          お使いのブラウザは video タグをサポートしていません。
        </video>
      )}
    </DialogContent>
  </Dialog>
);

export default VideoModal;
